import { Seq } from 'immutable';

// https://stackoverflow.com/questions/42617701/fromjs-to-nested-ordered-maps-with-immutable-js
export const fromJSOrdered = js => {
  if (typeof js !== 'object' || js === null) return js;
  return Array.isArray(js)
    ? Seq(js).map(fromJSOrdered).toList()
    : Seq(js).map(fromJSOrdered).toOrderedMap();
};
